
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"38","height":"38","rx":"3","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12.842 16.057h1.823m12.24 0h-1.693m-2.343 0v-3.215h-5.99v3.215m5.99 0h-5.99m5.99 0h2.343m-8.333 0h-2.214m0 0v10.848h10.547V16.057m-7.161 3.482l1.823 1.808m1.823 1.808l-1.823-1.808m0 0l1.823-1.808-3.646 3.616","stroke":"currentColor","stroke-width":"1.684","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    